<script>
    import BasketService from '../Services/Basket.js';

    export default {
        data() {
            return {
                service: BasketService
            }
        },
        render() {
            return this.$scopedSlots.default(
                this.service.getBasket()
            );
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Basket.vue